import { css } from 'styled-components';
import { media } from './media.js';

const headingStyle = heading => ({
  theme
}) => {
  return css(["margin:0;hyphens:auto;word-break:break-word;font-family:", ",Arial,Helvetica,sans-serif;font-size:", ";letter-spacing:", ";line-height:", ";font-weight:", ";", ""], theme.components.headings[heading].fontFamily, theme.components.headings[heading].mobile.fontSize, theme.components.headings[heading].mobile.letterSpacing, theme.components.headings[heading].mobile.lineHeight, theme.components.headings[heading].mobile.fontWeight, media.greaterThan('s')`
      font-size: ${theme.components.headings[heading].fontSize};
      letter-spacing: ${theme.components.headings[heading].letterSpacing};
      line-height: ${theme.components.headings[heading].lineHeight};
      font-weight: ${theme.components.headings[heading].fontWeight};
    `);
};
const headingMarginBottom = heading => ({
  theme
}) => {
  return css(["margin-bottom:", ";", ""], theme.components.headings[heading].mobile.marginBottom, media.greaterThan('s')`
      margin-bottom: ${theme.components.headings[heading].marginBottom};
    `);
};
const headingMarginTop = heading => ({
  theme
}) => {
  return css(["margin-top:", ";", ""], theme.components.headings[heading].mobile.marginTop, media.greaterThan('s')`
      margin-top: ${theme.components.headings[heading].marginTop};
    `);
};

export { headingMarginBottom, headingMarginTop, headingStyle };
//# sourceMappingURL=headingStyle.js.map
